<template>
    <div :class='none ? "footer none" : "footer"'>
        <div
            style="width: 60vw;height: 88%;margin: 0 auto;display: flex;justify-content: space-between;padding: 15px 0;box-sizing: border-box;">
            <div
                style="display: flex;flex-direction: column;justify-content: space-around;height: 100%;font-size: 14px;color: #fff;">
                <div style="font-size: 20px;">{{ zh_en == 'zh' ? configs.company : configs.company_en }}</div>
                <div>{{ zh_en == 'zh' ? configs.company_address : configs.company_address_en }}</div>
                <div>{{ zh_en == 'zh' ? configs.company_phone : configs.company_phone_en }}</div>
                <div>{{ zh_en == 'zh' ? configs.company_email : configs.company_email_en }}</div>


            </div>


            <div>
                <!-- 分享组件 -->
            </div>
			
        </div>
		<div class="text-color">雷诵芬堂（www.shlyszy.com）版权所有(c)2024-2099<a class="text-color" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011402021422" target="_blank">{{configs.beian}}</a></div>
        <img src="../static/images/footer.png" mode="mixHeight" style="position: absolute;right: 0;height:100%;top: 0;"
            alt="">
			
    </div>
</template>

<script>
// @ is an alias to /src
import {
    get_configs,
} from "@/api/api";
export default {
    props: {
        none: { default: true }
    },
    data() {
        return {
            configs: {
                company: '',
                company_en: '',
                company_address: '',
                company_address_en: '',
                company_email: '',
                company_phone_en: '',
                company_phone: '',
                company_email_en: ''
            }
        }
    },
    mounted() {
        get_configs().then((res) => {
            this.configs = res
        })
    },
    components: {
    },
    methods: {

    }

}
</script>


<style lang="less" scoped>
.footer {
    background-color: #8A2E26;
    width: 100%;
    height: 200px;
    position: absolute;
    bottom: 0;
    left: 0;
    overflow-x: hidden;
}
.text-color{
	color:#828282
}
.none {
    bottom: -150px;
}
</style>